import { TableTemplate } from "components/templates/default/table/TableTemplate";
import {
  LicenseCount,
  SubscriptionInfo,
} from "api/interfaces/recorderInterface.interface";
import LicenseInfo from "./LicenseInfo";
import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import { useCallback, useMemo, useState } from "react";
import { TitleComponentType } from "components/blocks/subheader/SubHeader";
type Props = {};

export default function RecorderListPage(props: Props): JSX.Element {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [titleComponent, setTitleComponent] =
    useState<TitleComponentType>("Recorder List");

  const [subscriptionInfo, setSubscriptionInfo] = useState<SubscriptionInfo>();
  const [licenseCount, setLicenseCount] = useState<LicenseCount>({
    totalCameraCount: 0,
    totalLicensedCameraCount: 0,
  });
  const keyword = useMemo(
    () => searchParams.get("keyword") ?? "",
    [searchParams]
  );
  const setKeyword = useCallback(
    (value: React.SetStateAction<string>) => {
      const nextKeyword = typeof value === "function" ? value(keyword) : value;

      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);

        if (nextKeyword) {
          next.set("keyword", nextKeyword);
        } else {
          next.delete("keyword");
        }

        next.delete("pageNum");
        return next;
      });
    },
    [keyword, setSearchParams]
  );
  const onClickSearch = useCallback(
    (keyword: string) => {
      setKeyword(keyword);
    },
    [setKeyword]
  );

  const [centerChildren, setCenterChildren] = useState<React.ReactNode | null>(
    null
  );
  const isRecorderListEditPage = location.pathname.startsWith(
    "/recorders/list/edit"
  );
  const outletContext = {
    keyword,
    setKeyword,
    setSubscriptionInfo,
    setLicenseCount,
    setTitleComponent,
    setCenterChildren,
  };
  return (
    <TableTemplate
      titleComponent={titleComponent}
      centerChildren={centerChildren}
      licenseInfo={
        isRecorderListEditPage ? null : (
          <LicenseInfo
            licenseCount={licenseCount}
            subscriptionInfo={subscriptionInfo}
          />
        )
      }
      noSearch={isRecorderListEditPage}
      keyword={isRecorderListEditPage ? undefined : keyword}
      onClickSearch={isRecorderListEditPage ? undefined : onClickSearch}
      requiredPermissions="manageRecordersAndGroups"
      className={
        location.pathname === "/recorders/list/edit"
          ? "bg-container"
          : undefined
      }
    >
      <Outlet context={outletContext} />
    </TableTemplate>
  );
}
